import request from '../../js/lib/request';
import currentLang from '../../js/lib/currentLang';

// country lookup / dropdown
const countryDD = document.getElementById('form__country');
const stateWrapper = document.getElementById('form__stateWrapper');
const stateDDWrapper = document.getElementById('form__stateDDWrapper');

if(countryDD)
{
	GetStates();
	countryDD.addEventListener('change', () => {
		GetStates();
	});

	function GetStates()
	{
		var stateDD = document.getElementById('form__state');

		if(stateDD)
		{
	
			request().get('/userform/getstates/' + countryDD.value + '?state=' + stateDD.value + '&lang=' + currentLang()).then(function(response) {
				if (response.length > 0) {
					//stateWrapper.setAttribute('style', 'display: block;');
					ShowStates();
					stateDD.innerHTML = response;
				}
				else
					//stateWrapper.setAttribute('style', 'display: none;');
					HideStates();
			});
	
			// also remove the validator icon if us/ca is chosen
			if(countryDD.value == 'US' || countryDD.value == 'CA')
				SetReqs('display: inline;');
			else
				SetReqs('display: none;');
		}

	}

	function SetReqs(changeTo)
	{
		const reqs = document.querySelectorAll('.ifCountry');
		for (var x = 0; x < reqs.length; x++) 
			reqs[x].setAttribute('style', changeTo);
	}

	function HideStates() {
		stateWrapper.setAttribute('style', 'display: none;');
	}

	function ShowStates(){
		stateWrapper.setAttribute('style', 'display: block;');
	}

	
}

// another validator for the epi form textarea, by Nicholas Albergo
var text = document.getElementsByClassName('epiTextCounterBox');
var remain = document.getElementsByClassName('epiTextCounter');

if(text.length > 0)
{
	for (var x = 0; x < text.length; x++) 
		remain[x].textContent = text[x].getAttribute('data-charlimit'); // dynamically pull limit from data-charLimit and set count to whatever limit is
	
	function charCount(e) {
		for (var x = 0; x < text.length; x++) {
			var limit = text[x].getAttribute('data-charlimit');		 // update limit and textCounter display		 
			if(limit && limit > 0)
			{
				remain[x].textContent = limit;  
		
				if (text[x].value.length >= (limit - (limit / 20)))		 // turn number counter red when close to limit 
					remain[x].classList.add('epiTextCounter-error');
				else
					remain[x].classList.remove('epiTextCounter-error');
				
				if (text[x].value.length > limit) {
					text[x].value = text[x].value.substring(0, limit);	  // trim text if it goes past limit
					remain[x].textContent = 0;
				}
				else {
					var counter = (limit - (text[x].value.length));		 
					remain[x].textContent = counter;
				}  
			}
		}
	}
	
	var e1 = document.getElementsByClassName('epiTextCounterBox');
	for (var z = 0; z < e1.length; z++) {
		e1[z].addEventListener('keydown', charCount);
		e1[z].addEventListener('keyup', charCount);
	}
}



// WEBPACK FOOTER //
// ../components/forms/form_validation.js